import { breakpoints, Button, Inline, Stack, Text, vars } from '@etg/wings';
import { ContentWrapper, variants } from '@eti/components';
import { css, mediaQueries } from '@eti/styles';
import { useMediaQuery } from 'usehooks-ts';
import { price as priceUtils } from '@eti/utils';
import { CABIN_UPGRADE } from '../../../products';
import AnimatePrice from './AnimatePrice';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const {
  inputs
} = vars.colors;
const stickyFooterStyles = css`
  align-items: center;
  bottom: 0;
  display: flex;
  margin-top: auto;
  position: sticky;
  width: 100%;
`;
const buttonContainerStyles = css`
  background-color: ${vars.colors.surface.primary};
  border-top: solid ${inputs.main} 1px;
  min-height: 80px;
  width: 100%;

  @media ${mediaQueries.small.only} {
    min-height: 104px;
  }
`;
const contentWrapperStyles = css`
  align-items: center;
  display: flex;
  gap: 8px;
  justify-content: space-between;

  @media ${mediaQueries.small.only} {
    align-items: start;
    flex-direction: column;
    padding: 8px 16px 16px;
  }
`;
const inlineStyles = css`
  flex: 1;

  @media ${mediaQueries.medium.up} {
    flex: initial;
  }
`;
const mobileButtonStyles = css`
  width: 100%;
`;
const mobilePriceStyles = css`
  @media ${mediaQueries.small.only} {
    justify-content: space-between;
    width: 100%;
  }
`;
const CabinUpgradeSummaryMobileView = _ref => {
  let {
    buttonLabel,
    onSave,
    screenReaderPrice,
    totalPrice,
    totalPriceLabel
  } = _ref;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Inline, {
      className: mobilePriceStyles,
      children: [totalPriceLabel && /*#__PURE__*/_jsx(Text, {
        variant: "16-bold",
        children: totalPriceLabel
      }), /*#__PURE__*/_jsx(AnimatePrice, {
        textVariant: "16-bold",
        totalPrice: totalPrice
      })]
    }), /*#__PURE__*/_jsx(Button, {
      "aria-label": `${buttonLabel} ${totalPriceLabel} ${screenReaderPrice}`,
      className: mobileButtonStyles,
      "data-testid": `${CABIN_UPGRADE.name}-mobile-price-proceed-button`,
      onClick: onSave,
      variant: variants.PRIMARY,
      children: buttonLabel
    })]
  });
};
const CabinUpgradeSummaryDesktopView = _ref2 => {
  let {
    buttonLabel,
    onSave,
    screenReaderPrice,
    totalPrice,
    totalPriceLabel
  } = _ref2;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [totalPriceLabel && /*#__PURE__*/_jsx(Text, {
      variant: "16-bold",
      children: totalPriceLabel
    }), /*#__PURE__*/_jsxs(Inline, {
      align: "end",
      alignY: "center",
      className: inlineStyles,
      spacing: 16,
      children: [/*#__PURE__*/_jsx(AnimatePrice, {
        textVariant: "24-emphasized",
        totalPrice: totalPrice
      }), /*#__PURE__*/_jsx(Button, {
        "aria-label": `${buttonLabel} ${totalPriceLabel} ${screenReaderPrice}`,
        "data-testid": `${CABIN_UPGRADE.name}-desktop-price-proceed-button`,
        onClick: onSave,
        variant: variants.PRIMARY,
        children: buttonLabel
      })]
    })]
  });
};
const CabinUpgradeSummary = _ref3 => {
  let {
    buttonLabel,
    onSave,
    totalPrice,
    totalPriceLabel
  } = _ref3;
  const isDesktopView = useMediaQuery(`(min-width: ${breakpoints._768})`);
  const price = priceUtils.formatPrice(totalPrice);
  const screenReaderPrice = priceUtils.replaceWithCurrencyName(price);
  return /*#__PURE__*/_jsx(Stack, {
    className: stickyFooterStyles,
    "data-testid": `${CABIN_UPGRADE.name}-sticky-footer`,
    spacing: 0,
    children: /*#__PURE__*/_jsx(Inline, {
      className: buttonContainerStyles,
      noWrap: true,
      spacing: 16,
      children: /*#__PURE__*/_jsx(ContentWrapper, {
        className: contentWrapperStyles,
        children: isDesktopView ? /*#__PURE__*/_jsx(CabinUpgradeSummaryDesktopView, {
          buttonLabel: buttonLabel,
          onSave: onSave,
          screenReaderPrice: screenReaderPrice,
          totalPrice: price,
          totalPriceLabel: totalPriceLabel
        }) : /*#__PURE__*/_jsx(CabinUpgradeSummaryMobileView, {
          buttonLabel: buttonLabel,
          onSave: onSave,
          screenReaderPrice: screenReaderPrice,
          totalPrice: price,
          totalPriceLabel: totalPriceLabel
        })
      })
    })
  });
};
export default CabinUpgradeSummary;
//# sourceMappingURL=CabinUpgradeSummary.js.map